import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { DrillTableDataset } from 'app/model/dataset/drill.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'DrillSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(DrillTableDataset) }
})
export class DrillCopySource extends TabularCopySource {
}
